import React from 'react';
import {Link} from 'react-router-dom';
import {Helmet} from 'react-helmet-async';

import './NotFound.css';

/**
 * Not Found page.
 */
export default function NotFound() {
    return (
        <section className="NotFound">
            <Helmet>
                <title>페이지를 찾을 수 없습니다 | 후루츠패밀리</title>
                <meta name="description" content={'후루츠패밀리 | 입력하신 페이지 주소를 다시 한번 확인해 주세요.'} />
                <meta httpEquiv="Status" content="404 Not Found" />
                <meta name="robots" content="noindex" />
            </Helmet>

            <span className="NotFound-big-number" aria-hidden="true">404</span>

            <div className="NotFound-content">
                <p className="NotFound-label">PAGE NOT FOUND</p>
                <h2 className="NotFound-title">페이지를 찾을 수 없습니다</h2>
                <p className="NotFound-description">
                    요청하신 페이지가 존재하지 않거나,<br />
                    주소가 변경되었을 수 있어요.
                </p>
                <Link className="NotFound-button" to="/">메인으로 돌아가기</Link>
            </div>
        </section>
    );
}
